import axios from '../library/axios';
import React, { useState, useEffect } from 'react';
import { getSlug, } from "../config/routes/guards/slug";

const fetchDataCount = async (idElement) => {
  const options = {
    url: `/chapters/countDocumentByIdVariable/${idElement}`,
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
    },
  };

  try {
    const response = await axios(options);
    console.log(response.data?.count)
    return response.data?.count;
  } catch (error) {
    console.error('Error fetching data count:', error);
    return 0;
  }
};


const ActionButton = ({ row, handleElemen, handleShow }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let isMounted = true;
    fetchDataCount(row.id).then((dataCount) => {
      if (isMounted) {
        setCount(dataCount);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [row.id]);

  return (
    <span
      role="button"
      class="badge badge-pill badge-primary pe-auto"
      onClick={() => {
        handleElemen(row.id);
        handleShow();
      }}
      title='Jumlah Dokumen'
    >
      {count !== null ? count : 'Loading...'}
    </span>
  );
};

export default ActionButton;